import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  modalRoot: {
    "& .MuiDialog-paper": {
      maxWidth: 351,
      width: "100%"
    },
    "& .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20,
      "& .MuiTypography-root": {
        fontSize: 18,
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        lineHeight: "23px"
      }
    },
    "& .MuiDialogContent-root": {
      padding: 0
    },
    "& .MuiDialogContent-dividers": {
      borderTop: `1px solid ${theme.palette.text.hint}`
    },
    "& .MuiTableRow-root:nth-child(2n) .MuiTableCell-root": {
      backgroundColor: "rgba(238, 238, 238, 0.5)"
    }
  },
  tableWorkoutRow: {
    display: "grid",
    gridTemplateColumns: "3fr 1.2fr 1.8fr",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ececec"
    }
  },
  tableWorkoutCell: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    padding: "8px 20px"
  },
  tableWorkoutName: {
    display: "flex",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 13,
    maxWidth: 175,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  tableWorkoutFacility: {
    display: "flex",
    alignItems: "center"
  },
  tableWorkoutFacilityCodeBullet: {
    position: "relative",
    display: "flex",
    left: -16
  },
  tableWorkoutFacilityCode: {
    position: "relative",
    display: "flex",
    left: -5
  },
  tableWorkoutDate: {
    display: "flex",
    justifyContent: "flex-end"
  },
  dialogLoader: {
    minHeight: 120
  }
}));
